<template>
    <BlogPaginationList
        :title="$t('newsLandPlanPage.heading')"
        :description="$t('newsLandPlanPage.description')"
        postsTag="NEWS_LAND_USE"
        routeName="news_landplan"
        :limit="3">
        <template v-slot:content>
            <PostPreview
                :id="'news_actual_landplans'"
                :title="$t('newsLandPlanPage.actualPage.title')"
                :previewText="$t('newsLandPlanPage.actualPage.description')"
                :attachments="[]"
                :imagePreview="actualPlanImagePreview"
                :to="localeRoute({name: 'news_actual_landplans'})"
            />
        </template>
    </BlogPaginationList>
</template>

<script>
import BlogPaginationList from '@/components/blog/BlogPaginationList';
import PostPreview from '@/components/PostPreview';

const imagePreview = '/css/images/homepage/actual_plans.png';

export default {
    components: {
        BlogPaginationList,
        PostPreview
    },
    data() {
        return {
            actualPlanImagePreview: imagePreview
        }
    }
}
</script>
